'use strict';

/**
 * Named gateway environments — lets callers pass `environment: 'production'`
 * instead of hardcoding a gatewayUrl. `gatewayUrl` (an explicit URL) always
 * takes priority over `environment` when both are given, so local/custom
 * setups (a different port, a new staging box, etc.) aren't locked out.
 */
const GATEWAY_ENVIRONMENTS = {
  production: 'https://api.bucksbox.in/gateway',
  staging: 'https://uatgateway.bucksbox.in',
};

/**
 * @param {{ gatewayUrl?: string, environment?: string }} config
 * @returns {string} the resolved gateway URL
 * @throws if neither gatewayUrl nor a recognized environment is given
 */
function resolveGatewayUrl(config) {
  if (config.gatewayUrl) return config.gatewayUrl;

  if (config.environment) {
    const url = GATEWAY_ENVIRONMENTS[config.environment];
    if (!url) {
      throw new Error(
        `Unknown environment "${config.environment}" — expected one of: ${Object.keys(GATEWAY_ENVIRONMENTS).join(', ')} (or pass gatewayUrl directly)`,
      );
    }
    return url;
  }

  throw new Error('gatewayUrl or environment is required');
}

module.exports = { GATEWAY_ENVIRONMENTS, resolveGatewayUrl };
